export default "597ebea02b65b4f8.svg"